<template>
    <div>
        <div class="ob1-skeleton my-2">
            <div class="ob1-skeleton-white" style="width: 150px; height: 20px" />
        </div>
        <div class="d-flex mb-2">
            <div class="flex-shrink-0 pe-1">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 30px; height: 30px" />
                </div>
            </div>
            <div class="flex-grow-1 align-self-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 150px; height: 10px" />
                </div>
            </div>
        </div>
        <div class="d-flex mb-2">
            <div class="flex-shrink-0 pe-1">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 30px; height: 30px" />
                </div>
            </div>
            <div class="flex-grow-1 align-self-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 150px; height: 10px" />
                </div>
            </div>
        </div>
        <div class="d-flex mb-2">
            <div class="flex-shrink-0 pe-1">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 30px; height: 30px" />
                </div>
            </div>
            <div class="flex-grow-1 align-self-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 150px; height: 10px" />
                </div>
            </div>
        </div>
        <div class="d-flex mb-2">
            <div class="flex-shrink-0 pe-1">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 30px; height: 30px" />
                </div>
            </div>
            <div class="flex-grow-1 align-self-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 150px; height: 10px" />
                </div>
            </div>
        </div>
        <div class="d-flex mb-2">
            <div class="flex-shrink-0 pe-1">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 30px; height: 30px" />
                </div>
            </div>
            <div class="flex-grow-1 align-self-center">
                <div class="ob1-skeleton">
                    <div class="ob1-skeleton-white" style="width: 150px; height: 10px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "DeviceFilterReviewsSkeleton",
}
</script>
